import { html, View } from 'rune-ts';
import klass from './CardPopupView.module.scss';
import { classes } from '@services/MarppleShop/shared/util';
import { font } from '@services/MarppleShop/shared/typography';
import { UtilImageS } from '@modules/Util/Image/S/Function/module/UtilImageS';
import { format } from 'date-fns';

type TProps = {
  device: 'PC' | 'Mobile';
  layout: 'List';
  list_thumbnail: string;
  title: string;
  is_soldout: boolean;
  creator_name: string;
  start_at: string;
  end_at: string;
};

/**
 * https://www.figma.com/design/Top00pi5q5ylSxEviOOciV/MarppleShop-Design-System?node-id=26352-43111&m=dev
 */
export class CardPopupView extends View<TProps> {
  protected override template({
    device,
    list_thumbnail,
    title,
    is_soldout,
    creator_name,
    start_at,
    end_at,
  }: TProps) {
    return html`<div
      class="${classes(klass.card_popup, {
        [klass.device_pc]: device === 'PC',
        [klass.device_mobile]: device === 'Mobile',
      })}"
    >
      <img
        alt=""
        src="${UtilImageS.getResizedUrl({
          url: list_thumbnail,
          width: 1920 * 2,
          format: 'jpeg',
          quality: 85,
        })}"
        class="${classes(klass.creator_view_thumbnail, {
          [klass.device_pc]: device === 'PC',
          [klass.device_mobile]: device === 'Mobile',
        })}"
      />

      <div class="${klass.creator_view_title}">
        <span class="${classes(klass.popup_title_text, font('18_semibold_2', '15_semibold'))}">
          ${html.preventEscape(title)}
        </span>

        <div class="${klass.text_wrapper}">
          ${is_soldout
            ? html`<span class="${classes(klass.soldout_text, font('14_medium', '13_medium'))}">
                Sold Out
              </span>`
            : null}
          <span class="${classes(klass.popup_title, font('14_medium', '13_medium'))}">
            ${html.preventEscape(creator_name)}
          </span>

          <span class="${classes(klass.popup_title_period, font('12_medium'))}">
            <span> ${format(new Date(start_at), 'yyyy-MM-dd')} </span>

            <span> ~ </span>

            <span> ${format(new Date(end_at), 'yyyy-MM-dd')} </span>
          </span>
        </div>
      </div>
    </div>`;
  }
}
